
import { ConnectionPositionPair, Overlay, OverlayRef} from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { Directive, ElementRef, Injector, Input, Renderer2 } from '@angular/core';
import { MiniGuideComponent } from '../components/mini-guide/mini-guide.component';
import { ElementPosition, OVERLAY_DATA, OVERLAY_REF } from '../interfaces/mini-guide';
//import { MiniGuidanceService } from '../services/common/mini-guidance.service';




@Directive({
  selector: '[appMiniGuide]'
})
export class MiniGuideDirective {


  @Input('MiniGuideKey') guidekey: string = '';


  positions = [
    new ConnectionPositionPair(
      { originX: 'center', originY: 'center' },
      { overlayX: 'start', overlayY: 'top' },
    ),
  ];

  constructor(
    //private miniGuideService: MiniGuidanceService,
    private overlay: Overlay,
    private elRef: ElementRef,
    private injector: Injector,
    private renderer: Renderer2
    ) {
    
  }

  showGuide(isFirst: boolean, isLast: boolean)
  {
    
    const elementPosition = this.getElementPosition();

    const positionStrategy = this.overlay.position().flexibleConnectedTo(this.elRef).withPositions(this.getConnentionPositionPair(elementPosition)).withPush(true).withLockedPosition();

    const scrollStrategy = this.overlay.scrollStrategies.block();

    const overlayRef = this.overlay.create({
      panelClass: 'mini-guide',
      positionStrategy: positionStrategy,
      scrollStrategy: scrollStrategy,
      hasBackdrop: true,
      backdropClass: 'mini-guide-backdrop',
    });

    const miniGuideProtal = new ComponentPortal(MiniGuideComponent, null ,this.createInjector(this.guidekey, isFirst , isLast,overlayRef));
    overlayRef.attach(miniGuideProtal);
    this.addStypes();
  }

  addStypes()
  {
    this.renderer.addClass(this.elRef.nativeElement, 'active-guide');
  }

  clearStyles()
  {
    this.renderer.removeClass(this.elRef.nativeElement, 'active-guide');
  }


  getConnentionPositionPair(elPos: ElementPosition): ConnectionPositionPair[]
  {
    let connectionPair = new ConnectionPositionPair(
      {
        originX: 'center',
        originY: 'center',
      },
      {
        overlayX: 'center',
        overlayY: 'center'
      },
      0,
      0
      );
    switch(elPos)
    {
      case ElementPosition.TopLeft:
        connectionPair.overlayX = 'end';
        connectionPair.overlayY = 'top';
        connectionPair.originX = 'start';
        connectionPair.originY = 'bottom';
        connectionPair.offsetX = 10;
        break;
      case ElementPosition.TopRight:
        connectionPair.overlayX = 'start';
        connectionPair.overlayY = 'top';
        connectionPair.originX = 'end';
        connectionPair.originY = 'bottom';
        connectionPair.offsetX = -10;
        break;
      case ElementPosition.CenterLeft:
        connectionPair.overlayX = 'end';
        connectionPair.overlayY = 'top';
        connectionPair.originX = 'start';
        connectionPair.originY = 'center';
        connectionPair.offsetX = 10;
        break;
      case ElementPosition.CenterRight:
        connectionPair.overlayX = 'start';
        connectionPair.overlayY = 'top';
        connectionPair.originX = 'end';
        connectionPair.originY = 'center';
        connectionPair.offsetX = -10;
        break;
      case ElementPosition.BottomLeft:
        connectionPair.overlayX = 'end';
        connectionPair.overlayY = 'bottom';
        connectionPair.originX = 'start';
        connectionPair.originY = 'top';
        connectionPair.offsetX = 10;
        break;
      case ElementPosition.BottomRight:
        connectionPair.overlayX = 'start';
        connectionPair.overlayY = 'bottom';
        connectionPair.originX = 'end';
        connectionPair.originY = 'top';
        connectionPair.offsetX = -10;
        break;
      case ElementPosition.TopScreenWidth:
        connectionPair.overlayX = 'center';
        connectionPair.overlayY = 'top';
        connectionPair.originX = 'center';
        connectionPair.originY = 'bottom';
        connectionPair.offsetY = 10;
        break;
      case ElementPosition.BottomScreenWidth:
        connectionPair.overlayX = 'center';
        connectionPair.overlayY = 'bottom';
        connectionPair.originX = 'center';
        connectionPair.originY = 'top';
        connectionPair.offsetY = -10;
        break;
      case ElementPosition.LeftScreenHeight:
        connectionPair.overlayX = 'end';
        connectionPair.overlayY = 'center';
        connectionPair.originX = 'start';
        connectionPair.originY = 'center';
        connectionPair.offsetX = 10;
        break;
      case ElementPosition.RightScreenHeight:
        connectionPair.overlayX = 'start';
        connectionPair.overlayY = 'center';
        connectionPair.originX = 'end';
        connectionPair.originY = 'center';
        connectionPair.offsetX = -10;
        break;
      case ElementPosition.FullScreen: //overlay z-index issue need fix when ever needed
        connectionPair.overlayX = 'center';
        connectionPair.overlayY = 'center';
        connectionPair.originX = 'start';
        connectionPair.originY = 'top';
        break;
    }

    return [connectionPair];
  }

  private createInjector(keyId: string, isFirst: boolean, isLast: boolean, overlayRef: OverlayRef): PortalInjector {
    const injectorTokens = new WeakMap();
    injectorTokens.set(OVERLAY_DATA, {
      id: keyId,
      isFirst: isFirst,
      isLast: isLast,
    });
    injectorTokens.set(OVERLAY_REF, overlayRef)
    return new PortalInjector(this.injector, injectorTokens);
  }

  getElementPosition(): ElementPosition
  {
    const windowSize = {x: window.innerWidth, y: window.innerHeight};
    const pos = this.elRef.nativeElement.getBoundingClientRect() as DOMRect;
    const halfOfScreenWidth = windowSize.x / 2;
    const halfOfScreenHeight = windowSize.y / 2;

    if(pos.width > halfOfScreenWidth && pos.height > halfOfScreenHeight)
    {
      return ElementPosition.FullScreen;
    }

    if(pos.width > halfOfScreenWidth)
    {
      if(pos.y > halfOfScreenHeight)
      return ElementPosition.BottomScreenWidth;

      return ElementPosition.TopScreenWidth;
    }

    if(pos.height > halfOfScreenHeight)
    {
      if(pos.x > halfOfScreenWidth)
      return ElementPosition.RightScreenHeight;

      return ElementPosition.LeftScreenHeight;
    }

    if(pos.y < 30)
    {
      //top of screen

      if(pos.x >= halfOfScreenWidth)
      {
        return ElementPosition.TopRight;
      }else{
        return ElementPosition.TopLeft;
      }
    }


    if(pos.y >= 30 && pos.y <= windowSize.y - 200)
    {
      //middle of screen
      if(pos.x >= halfOfScreenWidth)
      {
        return ElementPosition.CenterRight;
      }else{
        return ElementPosition.CenterLeft;
      }
    }

    if(pos.y > windowSize.y - 200)
    {
      //bottom of screen
      if(pos.x >= halfOfScreenWidth)
      {
        return ElementPosition.BottomRight;
      }else{
        return ElementPosition.BottomLeft;
      }
    }
  }

}
